<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card>
      <div slot="header">
        <vs-title back>Yeni Kullanıcı Oluştur</vs-title>
      </div>

      <form v-if="! saved" @submit.prevent="save">
        <div class="tw-flex tw-flex-wrap">
          <div class="tw-w-full md:tw-w-1/2 tw-my-1">
            <vs-input
                label="Kullanıcı Adı"
                v-model="obj.columns.username"
                name="username"
                id="username"
                required
                :danger="errors.has('username')"
                :danger-text="errors.get('username')"
                val-icon-danger="mdi-alert"
            />
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1 md:tw-pl-4">
            <vs-input
                label="Email"
                type="email"
                v-model="obj.columns.email"
                name="email"
                id="email"
                required
                :danger="errors.has('email')"
                :danger-text="errors.get('email')"
                val-icon-danger="mdi-alert"
            />
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1">
            <vs-input
                label-placeholder="Şifre"
                :type="passwordType"
                v-model="temppass"
                name="password"
                id="password"
               
                
                required
                v-on:icon-click="togglePassword = !togglePassword"
                :danger="errors.has('password')"
                :danger-text="errors.get('password')"
                val-icon-danger="mdi-alert"
            />
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1 md:tw-pl-4">
            <vs-input
                label-placeholder="Şifre Tekrar"
                :type="passwordType"
                v-model="temppass2"
                name="password_confirmation"
                id="password_confirmation"
             
                required
                :danger="errors.has('password')"
                :danger-text="errors.get('password')"
                val-icon-danger="mdi-alert"
            />
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1">
            <vs-input
                label="Ad"
                v-model="obj.columns.first_name"
                name="first_name"
                id="first_name"
                required
                :danger="errors.has('first_name')"
                :danger-text="errors.get('first_name')"
                val-icon-danger="mdi-alert"
            />
          </div>
          <div class="tw-w-full md:tw-w-1/2 tw-my-1 md:tw-pl-4">
            <vs-input
                label="Soyad"
                v-model="obj.columns.last_name"
                name="last_name"
                id="last_name"
                required
                :danger="errors.has('last_name')"
                :danger-text="errors.get('last_name')"
                val-icon-danger="mdi-alert"
            />
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1">
            <vs-input
                label-placeholder="Telefon"
                type="tel"
                v-model="obj.columns.phone"
                name="phone"
                id="phone"
                required
                :danger="errors.has('phone')"
                :danger-text="errors.get('phone')"
                val-icon-danger="mdi-alert"
            />
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1 md:tw-pl-4">
            <vs-select
                label="Cinsiyet"
                v-model="obj.columns.gender"
                :danger="errors.has('gender')"
                :danger-text="errors.get('gender')"
            >
              <vs-select-item
                  v-for="item in obj.systemGenders"
                  :key="item"
                  :value="item"
                  :text="item"
              />
            </vs-select>
          </div>

          <div class="tw-w-full md:tw-w-1/2 tw-my-1">
            <vs-select
                label="Rol"
                v-model="temprol"
                
                :danger="errors.has('roles')"
                :danger-text="errors.get('roles')"
            >
              <vs-select-item
                  v-for="item in rolDegisken"
                  :key="item"
                  :value="item"
                  :text="item"
              />
            </vs-select>
          </div>

           <br/>
            <div class="tw-w-full md:tw-w-1/2 tw-my-1 md:tw-pl-4">
             <vs-select
                             label="Kullanıcı Birimi"
                            placeholder="Birim Listesi"
                            label-placeholder="Autocomplete"
                            class="fullW"
                            autocomplete
                            v-model="tempbirim"
                            >
                            <vs-select-item :key="index" :value="item" :text="item" v-for="item,index in $options2" />
                          </vs-select>
 </div>
         <br/>

        </div>

        <vs-error :errors="errors"></vs-error>
          <br><br>
        <vs-button  color="#1f74ff" button="submit">Kullanıcı Oluştur</vs-button>
      </form>

      <div v-else>
        <h4>Kayıt Başarılı!</h4>

        <vs-button type="gradient" color="success" @click="addNew">Yeni Ekle</vs-button>
      </div>

    </vs-card>

  </div>
</template>

<script>
  import User from "@/libs/users/User";
  import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'

  export default {
    name: "users-create",
    title: "Add a New User",
    data() {
      return {
        obj: new User(),
        pass2:'',
        temppass:'',
        user: getUserFromStorage(),
        rolDegisken:[],
        tempbirim:'',
        temprol:'user',
        loading: false,
        togglePassword: false,
      };
    },
    computed: {
      passwordType() {
        return this.togglePassword ? 'text' : 'şifre'
      },
      saved() {
        return this.obj.saved
      },
      submitted() {
        return this.obj.form.submitted
      },
      contaminated() {
        return this.obj.form.errorDetected
      },
      errors() {
        return this.obj.form.errors
      }
    },
    watch: {
      contaminated(val) {
        this.loading = false
      },
      submitted(val) {
        if(val)
          this.loading = false
      },
      saved(val) {
        if(val) {
          // handle added
        }
      },
    },
    methods: {
      save() {
        this.loading = true
        this.obj.columns.roles=this.temprol
        this.obj.columns.unit=this.tempbirim
        this.obj.columns.rol=this.obj.columns.roles
       
        this.obj.columns.password_confirmation=this.temppass2
        this.obj.columns.password=this.temppass
         this.obj.columns.pass2=this.temppass
        this.obj.create()
      },
      addNew() {
        this.obj.reset();
        this.obj.saved = false
      }
    },
    mounted() {
      this.obj.reset();
      
       if(this.user.rol=="İdari Admin"){
          this.rolDegisken=["user", 'Öğrenci', 'Akademisyen', 'İdari Admin']
      }else{
          this.rolDegisken =this.obj.systemRoles
      }
    }
  };
</script>

<style>
.fullW{
  width:85%;
}
</style>